import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "01ab9dQh8hJIJUQh372+7uY", "NumGrowth", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Label } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
var NumGrowth = (_dec = menu("act/NumGrowth"), ccclass(_class = _dec(_class = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NumGrowth, _Component);

  function NumGrowth() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_aimNum", 0);

    _defineProperty(_assertThisInitialized(_this), "_curNum", 0);

    _defineProperty(_assertThisInitialized(_this), "_step", 0);

    _defineProperty(_assertThisInitialized(_this), "_preStr", "");

    _defineProperty(_assertThisInitialized(_this), "_endStr", "");

    return _this;
  }

  var _proto = NumGrowth.prototype;

  _proto.start = function start() {};

  _proto.growth = function growth(curNum, aimNum, preStr, endStr) {
    if (preStr === void 0) {
      preStr = "";
    }

    if (endStr === void 0) {
      endStr = "";
    }

    this._curNum = curNum;
    this._aimNum = aimNum;
    this._step = Math.round((this._aimNum - this._curNum) / 30);
    this._preStr = preStr;
    this._endStr = endStr;
  };

  _proto.update = function update(dt) {
    if (this._curNum == this._aimNum) return;

    if (Math.abs(this._curNum - this._aimNum) < 10) {
      this._step = this._curNum < this._aimNum ? 1 : -1;
    }

    if (this._curNum != this._aimNum) {
      this._curNum += this._step;

      if (this._step > 0 && this._curNum > this._aimNum || this._step < 0 && this._curNum < this._aimNum) {
        this._curNum = this._aimNum;
      }

      var aimNum = this.switchUnit(this._curNum);
      this.node.getComponent(Label).string = this._preStr + aimNum + this._endStr;
    }
  };

  _proto.switchUnit = function switchUnit(num) {
    var numStr = ["K", "M", "B", "T"];
    var totalNum = 0;
    var tempNum = num;

    while (tempNum > 1000) {
      totalNum++;
      tempNum = tempNum / 1000;
    }

    var strU = "";

    if (totalNum > 0) {
      if (totalNum > numStr.length) {
        strU = numStr[numStr.length - 1];
      } else {
        strU = numStr[totalNum - 1];
      }

      return Math.round(tempNum) + strU;
    } else {
      return num + "";
    }
  };

  return NumGrowth;
}(Component), _temp)) || _class) || _class);
export { NumGrowth as default };

_cclegacy._RF.pop();